<template>
  <main id="home_view" class="homevisual">
		<div v-if="home.mandate_status === 'complete'">
			<messages-home v-if="!preview"
        :home="home"
        :openDiscution="triggerForDiscussion"
        :preview="preview"
        :is-public="isPublic"
        @joinGroup="joinGroup">
      </messages-home>
		</div>

    <div class="home_view">
      <div class="home_header">
        <div class="home_summary">
          <div class="home_summary_main">
            <div class="home_options">
              <div class="home_provider">Géré par Cooloc</div>
              <!--div class="home_favorites">
                <span>Ajouter aux favoris</span>
                <img src="/static/images/icons/heart.svg" width="22" height="20" />
              </div-->
            </div>
            <h1 class="home_title">
              Co-location {{ home.city }} {{ home.postal_code }}
            </h1>
            <div class="tags">
              <div>Superficie: {{ home.surface_area }}m²</div>
              <div>{{ roomsCount }} chambres</div>
              <div v-if="home.bathroom_count && home.bathroom_count > 0">{{ home.bathroom_count }} {{ home.bathroom_count > 1 ? 'salles de bain partagées' : 'salle de bain partagée' }}</div>
              <div v-if="privateBathroomsCount > 0">{{ privateBathroomsCount }} {{ privateBathroomsCount > 1 ? 'salles de bain privatives' : 'salle de bain privative' }}</div>
              <div v-if="home.eligible_apl">Eligible APL</div>
            </div>
          </div>
          <div class="home_share">
            <div class="ref">Référence: <span style="font-weight: 700; color: black">{{ home.annonce_id }}</span></div>
            <div class="label">Partager l'annonce</div>
            <div class="buttons">
              <email-button btnText :url="home.public_url"
                :subject="shareTitle"
                :message="shareText"
                :title="shareTitle">
              </email-button>
              <whats-app-button btnText :url="home.public_url"
                :message="shareText"
                :title="shareTitle">
              </whats-app-button>
              <facebook-button btnText :url="home.public_url"
                 :title="shareTitle"
                 :message="shareText"
                 hashtags="#colocation,#coliving">
              </facebook-button>
              <twitter-button btnText :url="home.public_url"
                :title="shareTitle"
                hashtags="#colocation,#coliving">
              </twitter-button>
            </div>
          </div>
        </div>

        <div class="home_pictures">
          <div class="home_mainpicture"
            :style="imgStyle(homeImages[0])"
            @click="openLightbox(medias, 0)">
          </div>
          <div class="home_thumbnails">
            <div :style="imgStyle(homeImages[1])" v-if="homeImages.length >= 2"
                 @click="openLightbox(medias, 1)">
            </div>
            <div :style="imgStyle(homeImages[2])" v-if="homeImages.length >= 3"
                 @click="openLightbox(medias, 2)">
            </div>
            <div :style="imgStyle(homeImages[3])" v-if="homeImages.length >= 4" class="last_pic"
                 @click="openLightbox(medias, 3)">
              <div v-if="medias.length > 1">Voir les {{ medias.length }} photos</div>
            </div>
          </div>
        </div>

        <div class="home_location_address">
          <img class="home_location_icon" src="/static/images/icons/location.svg" />
          <div class="home_address" style="margin-left: 8px">
            {{ home.city }} {{ home.postal_code }}
          </div>
          <button class="light" style="margin-left: 40px" @click="gotoMap">Estimer mon temps de trajet</button>
        </div>
        <div class="home_actions">
          <ui-button type="button" @click="gotoCalendar" v-if="hasMandate">
            Visiter la co-location
          </ui-button>
          <ui-button type="button" v-if="video360" @click="openVirtualVisit">Visite virtuelle</ui-button>
          <ui-button type="button" :reverse="true" @click="requestWarranty" :loading="warranty.loading"
                     v-if="hasMandate && hasLeasableRoom">
            Déposer un dossier
          </ui-button>
          <ui-button v-if="!hasMandate" @click="contactOwner">Contacter le propriétaire</ui-button>
        </div>
      </div>

      <div class="home_block" v-if="tenants && tenants.length > 0">
        <div class="home_subtitle">
          <h2>Les co-locataires</h2>
        </div>
        <div class="home_tenants">
          <div v-for="tenant of tenants" class="home_tenant" :key="tenant.id">
            <router-link class="home_tenant_pic" :to="`/users/${tenant.id}/profile`" v-if="!preview && (!isPublic || user)">
              <div :style="userStyle(tenant)" class="home_tenant_pic" />
            </router-link>
            <div v-else :style="userStyle(tenant)" class="home_tenant_pic" />
            <div>
              <router-link class="home_tenant_name" :to="`/users/${tenant.id}/profile`" v-if="!preview && (!isPublic || user)">
                <div class="home_tenant_name">{{ tenant.firstname }} {{ tenant.name.substring(0, 1) }}.</div>
              </router-link>
              <div v-else class="home_tenant_name">{{ tenant.firstname }} {{ tenant.name.substring(0, 1) }}.</div>
              <div class="home_tenant_info">{{ age(tenant) }} ans</div>
            </div>
          </div>
        </div>
        <div v-if="hasMandate" style="margin-top: 16px">
          <ui-button type="button" @click="triggerForDiscussion += 1">Rejoindre la chatroom</ui-button>
        </div>
      </div>

      <div class="home_block">
        <div class="home_subtitle">
          <h2>Les chambres</h2>
          <span v-if="roomsLeasable === 0">Aucune chambre disponible actuellement</span>
          <span v-else>{{ roomsLeasable }} {{ pluralize('disponible', roomsLeasable) }}</span>
        </div>
        <div class="home_block_content">
          <div class="home_rooms">
            <div v-for="(room, i) of home.rooms" class="home_room" :key="i">
              <div class="homevisual__room__nopic" v-if="!room.images || !room.images.list.length"
                   @click="openLightbox(roomMedias(room), 0)">
              </div>
              <hooper :id="'hooper'+i" v-else :wheel-control="false">
                <hooper-slide
                  v-for="(img, i) of (room.images && room.images.list ? room.images.list : [])"
                  :key="i"
                  :style="imgStyle(img)">
                </hooper-slide>
                <div slot="hooper-addons"
                     style="position: absolute; left: 0; right: 0; top: 0; height: 100%; background: transparent"
                     @click="openLightbox(roomMedias(room), 0)">
                </div>
                <hooper-pagination slot="hooper-addons" />
                <hooper-navigation slot="hooper-addons" />
              </hooper>

              <div class="home_room_info">
                <div>{{ room | roomName('Chambre ') }} - {{ room.surface_area }}m²</div>
                <div class="price">{{ roomAmount(room) | money }}<span class="subprice">&nbsp;par mois</span></div>
              </div>
              <div class="tags" style="margin-top: 8px">
                <div v-if="room.has_bathroom">SdB privative</div>
                <div v-else-if="home.bathroom_count >= 1">SdB partagée</div>
                <div v-if="room.has_balcony">Balcon</div>
                <div v-if="room.has_toilet">Toilettes séparées</div>
                <div v-if="room.has_parking">Parking</div>
                <div v-if="room.has_double_glazing">Dble vitrage</div>
                <div v-if="room.has_air_conditioning">Climatisation</div>
              </div>
              <div style="margin-top: 12px">
                <button class="light" style="width: 100%" @click="openLightbox(roomComponents, i)">Plus d'informations</button>
              </div>

              <div class="home_room_leasable">
                <div class="label">{{ room.leasable ? 'Libre' : 'Occupée' }}</div>
                <div class="color" :style="{ 'background-color': room.leasable ? '#00A23A' : '#FBBA1F' }"></div>
              </div>

              <div v-if="!room.leasable && room.user && room.user.avatar" :style="userStyle(room.user)" class="home_room_tenant_pic" />
            </div>
          </div>
        </div>
      </div>

      <div id="map" class="home_block">
        <div class="home_subtitle">
          <h2>Le quartier</h2>
        </div>
        <div class="home_block_content">
          <div>
            <h3>Environnement immédiat</h3>
            <div class="tags">
              <div v-if="home.environments.includes(1)">Montagne</div>
              <div v-if="home.environments.includes(2)">Plage</div>
              <div v-if="home.environments.includes(3)">Ville</div>
              <div v-if="home.environments.includes(4)">Campagne</div>
            </div>
          </div>
          <div class="home_location">
            <div class="home_location_map">
              <gmap-map :center="currentLocation" :zoom="home.address ? 14 : 13" :options="{ disableDefaultUI: true }">
                <gmap-marker v-if="home.address"
                  :position="currentLocation"
                  :clickable="false"
                  :draggable="false">
                </gmap-marker>
                <gmap-circle v-else
                  :center="currentLocation"
                  :clickable="false"
                  :draggable="false"
                  :radius="500"
                  :options="{ fillColor: '#d90f16', fillOpacity: 0.2, strokeOpacity: 0 }">
                </gmap-circle>
              </gmap-map>
            </div>
            <div class="home_location_access">
              <div class="home_location_access_subtitle">Estimer votre temps de trajet depuis ce logement</div>
              <div class="home_location_access_dest">
                <div class="label">Depuis votre coliving</div>
                <img class="label" src="/static/images/icons/right-arrow.svg" width="12" height="12" />
                <div class="input">
                  <gmap-autocomplete ref="routeAddress" :value="route.address"
                    @input.native="route.address = $event.target.value"
                    @place_changed="route.address = $refs.routeAddress.$el.value; calcRoute()"
                    :componentRestrictions="{ country: home.country_code }"
                    :options="{ bounds: {
                      north: home.latitude + 0.1,
                      south: home.latitude - 0.1,
                      east: home.longitude + 0.1,
                      west: home.longitude - 0.1,
                    } }"
                    placeholder="Saisir une destination... ">
                  </gmap-autocomplete>
                </div>
              </div>
              <div class="home_location_access_results" v-if="route.loading">
                <div style="margin-top: 16px">Recherche en cours...</div>
                <div class="loader-wrapper" style="height: 50px">
                  <div class="loader big"></div>
                </div>
              </div>
              <div class="home_location_access_results" v-else-if="route.results">
                <div class="icons">
                  <div v-if="route.results.driving">
                    <img src="/static/images/icons/driving.svg" />
                    <span v-html="route.results.driving"></span>
                  </div>
                  <div v-if="route.results.transit">
                    <img src="/static/images/icons/transit.svg" />
                    <span v-html="route.results.transit"></span>
                  </div>
                  <div v-if="route.results.walking">
                    <img src="/static/images/icons/walking.svg" />
                    <span v-html="route.results.walking"></span>
                  </div>
                  <div v-if="route.results.bicycling">
                    <img src="/static/images/icons/bicycling.svg" />
                    <span v-html="route.results.bicycling"></span>
                  </div>
                </div>
                <div class="info" v-if="route.results && route.address">
                  Ceci est une estimation, il se peut que les données<br> varient en fonction de critères extérieurs.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home_block">
        <div class="home_subtitle">
          <h2>L&apos;appartement</h2>
        </div>
        <div class="home_block_content">
          <div>
            <h3>Informations principales</h3>
            <div class="tags">
              <div v-for="tag of homeTags" :key="tag">{{ tag }}</div>
            </div>
          </div>
          <div class="home_description" v-if="home.description_approved">
            <pre>{{ home.description }}</pre>
          </div>
          <div class="home_included">
            <div style="display: flex; flex-wrap: wrap; column-gap: 40px; row-gap: 16px">
              <div style="width: 100%" v-if="sharedServices.length > 0">
                <span>Compris dans les charges</span><span style="color: #A6A9AC">&nbsp;(au forfait)</span>
                <div class="tags" style="margin-top: 12px">
                  <div v-for="tag of sharedServices" :key="tag"><img src="/static/images/icons/tag-check.svg" width="16" height="16" />&nbsp;{{ tag }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="sharedPlaces">
            <h3>Parties communes</h3>
            <div class="tags">
              <div v-for="tag of sharedPlaces" :key="tag">{{ tag }}</div>
            </div>
            <div style="margin-top: 24px">Eléments techniques</div>
            <div style="display: flex; flex-wrap: wrap; column-gap: 40px; row-gap: 16px; margin-top: 12px">
              <div style="display: flex; flex-direction: column">
                <span>DPE</span>
                <div class="homevisual__maininfo__letters homevisual__maininfo__letters--dpe">
                  <div v-for="letter of letters" :key="letter"
                       :class="{ 'homevisual__maininfo__letters--active': letter === dpeLetter }">
                    {{ letter }}
                  </div>
                </div>
              </div>
              <div style="display: flex; flex-direction: column">
                <span>GES</span>
                <div class="homevisual__maininfo__letters homevisual__maininfo__letters--ges">
                  <div v-for="letter of letters" :key="letter"
                       :class="{ 'homevisual__maininfo__letters--active': letter === gesLetter }">
                    {{ letter }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="calendar" class="home_block" v-if="hasMandate && !preview">
        <div class="home_subtitle">
          <h2>Prendre rendez-vous</h2>
        </div>
        <div class="home_block_content">
          <div style="margin-left: auto; margin-right: auto">
            <agenda title="Sélectionnez un créneau disponible (ci-dessous en vert)"
                    :home-id="home.id"
                    :user-id="user ? user.id : null"
                    :allow-no-slot="!home.no_slot_requests_allowed"
                    @reserveMeet="reserveMeet">
            </agenda>
          </div>
        </div>
      </div>
    </div>

    <fsLightbox v-bind="lightbox"/>

    <ui-modal v-if="connectionModal" @close="connectionModal = false" :title="connectionModal.title">
      <div>{{ connectionModal.subtitle }}</div>

      <template slot="buttons">
        <div class="group-button group-button-text">
          <ui-button class="white-button"
                  @click="setPageAfterLogin(connectionModal.pageAfterLogin); $router.push({ name: 'SignIn' })">
            Se connecter
          </ui-button>
          <div class="divider-btn"></div>
          <ui-button class="white-button"
                  @click="setPageAfterLogin(connectionModal.pageAfterLogin); $router.push({ name: 'SignUpSelect' })">
            S'inscrire
          </ui-button>
        </div>
      </template>
    </ui-modal>

    <contact-modal
      v-if="contactModalData"
      @close="contactModalData = null"
      @confirm="contactModalData.confirm"
      v-bind="contactModalData"
    />
  </main>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { Hooper, Navigation as HooperNavigation, Pagination as HooperPagination, Slide as HooperSlide } from 'hooper'
import FsLightbox from 'fslightbox-vue'
import EmailButton from '@/components/share/EmailButton'
import WhatsAppButton from '@/components/share/WhatsAppButton'
import FacebookButton from '@/components/share/FacebookButton'
import TwitterButton from '@/components/share/TwitterButton'
import { eventBus, registrationHelpers } from '@/main'
import { optionFields } from '@/components/mixins/optionFields'
import RoomVisual from './HomeVisualRoom'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyALbNIIXasdUmwQ-Ko9lSbp89RerFaqxbg',
    libraries: 'places',
  },
})

const youtubeRegex = /^https:\/\/(youtu\.be\/([a-z0-9_-]+)|(www\.|m\.])?youtube\.com\/watch\?vi?=([a-z0-9_-]+))/i

export default {
  mixins: [optionFields],
  props: {
    home: Object,
    approvedOnly: Boolean,
    preview: Boolean,
    loadedUser: Object,
  },
  data: () => ({
    connectionModal: false,
    triggerForDiscussion: 0,
    letters: 'ABCDEFG'.split(''),
    youtubeRegex,
    lightbox: {
      toggler: false,
      slide: 0,
      sources: [],
      key: 0,
    },
    collapsibles: {
      places: false,
      services: false,
      infos: false,
      desc: false,
    },
    route: {
      results: false,
      loading: false,
      address: '',
    },
    warranty: {
      loading: false,
    },
    contactModalData: null,
    options: [],
    showConfirmModal: false,
    user: null,
  }),
  computed: {
    currentLocation() {
      return {
        lat: this.home.latitude || 0,
        lng: this.home.longitude || 0,
      }
    },
    medias() {
      if (!this.home.images) {
        return []
      }
      const res = this.home.images.list.map(img => '/image/' + img.id + '/0/0')
      if (this.youtube) {
        res.push(this.fixYoutubeUrl(this.youtube))
      }
      if (this.video360 && youtubeRegex.test(this.video360)) {
        res.push(this.fixYoutubeUrl(this.video360))
      }
      return res
    },
    roomsLeasable() {
      return this.home.rooms.reduce((count, r) => count + (r.leasable ? 1 : 0), 0)
    },
    homeImages() {
      if (!this.home.images || !this.home.images.list || this.home.images.list.length < 1) {
        return []
      }
      return this.home.images.list
    },
    roomsCount() {
      return Math.max(this.home.rooms.length || 0, this.home.bedroom_count)
    },
    privateBathroomsCount() {
      return this.home.rooms.reduce((count, r) => count + (r.has_bathroom ? 1 : 0), 0)
    },
    homeTags() {
      const homeTags = []
      if (this.home.habitat_type === 11) {
        homeTags.push(`Maison ${this.home.room_count} pièces`)
      } else {
        homeTags.push(`Appartement ${this.home.room_count} pièces`)
      }
      homeTags.push(`Superficie: ${this.home.surface_area}m²`)
      homeTags.push(`${this.roomsCount} Chambres`)
      if (this.home.bathroom_count > 1) {
        homeTags.push(`${this.home.bathroom_count} Salles de bain`)
      } else if (this.home.bathroom_count === 1) {
        homeTags.push('Une Salle de bain')
      }
      homeTags.push(`Parties communes: ${this.home.livingroom_surface}m²`)
      if (this.home.floor > 0) {
        homeTags.push(`${this.home.floor}${this.ieme(this.home.floor)} étage`)
      }
      return homeTags
    },
    sharedPlaces() {
      const home = this.home
      return Object.entries({
        has_library: 'Bibliothèque',
        has_laundry_room: 'Buanderie',
        has_office: 'Bureau',
        cave: 'Cave',
        has_fitted_kitchen: 'Cuisine équipée',
        open_kitchen: 'Cuisine ouverte',
        has_cellier: 'Cellier',
        has_outbuilding: 'Dépendance',
        has_attic: 'Grenier',
        has_hammam: 'Hammam',
        has_dining_room: 'Salle à manger',
        has_movie_room: 'Salle de cinéma',
        has_game_room: 'Salle de jeux',
        has_sports_hall: 'Salle de sport',
        has_sauna: 'Sauna',
        has_shared_bathroom: 'Salle de bain partagée',
        has_balcony: 'Balcon',
        has_terrace: 'Terrasse',
        has_dryer: 'Sèche-linge',
        has_double_glazing: 'Double vitrage',
        has_jacuzzi: 'Jacuzzi',
        has_washing_machine: 'Lave-linge',
        has_dishwasher: 'Lave vaisselle',
        handicap_compliant: 'Accès aux personnes à mobilité réduite',
      })
        .filter(([key, value]) => !!home[key])
        .map(([key, value]) => value)
        .concat(home.common_area_others.split(/\s*,\s*/g).map(this.$options.filters.capitalize))
        .filter(val => !!val)
    },
    sharedServices() {
      const home = this.home
      return Object.entries({
        premium_tv_included: 'Abonnement TV premium',
        has_wifi: 'Abonnement internet',
        cooking_lessons_included: 'Cours de cuisine',
        sports_lesson_included: 'Cours de sport (yoga, fitness, ...)',
        gardener_included: 'Jardinier',
        housework_included: 'Ménage',
      })
        .filter(([key, value]) => !!home[key])
        .map(([key, value]) => value)
        .concat(home.charge_included_others.split(/\s*,\s*/g).map(this.$options.filters.capitalize))
        .filter(val => !!val)
    },
    outdoor() {
      const home = this.home
      return Object.entries({
        has_elevator: 'Ascenseur',
        has_barbecue: 'Barbecue',
        has_electric_charging_station: 'Borne de recharge électrique',
        has_pool: 'Piscine',
        has_chicken_coop: 'Poulailler',
        has_bike_room: 'Local à vélo',
        has_parking: 'Parking',
        separate_toilet: 'Toilettes',
      })
        .filter(([key, value]) => !!home[key])
        .map(([key, value]) => value)
        .concat(home.outdoor_others.split(/\s*,\s*/g).map(this.$options.filters.capitalize))
        .filter(val => !!val)
    },
    dpeLetter() {
      const name = this.getFieldName(this.home.heater_diag_energy_category, 'diagenergyarray')
      return name.charAt(0).toUpperCase()
    },
    gesLetter() {
      const name = this.getFieldName(this.home.heater_diag_gaz_category, 'diaggazarray')
      return name.charAt(0).toUpperCase()
    },
    youtube() {
      return (!this.approvedOnly || this.home.youtube_approved) && this.home.youtube
    },
    video360() {
      return (!this.approvedOnly || this.home.virtual_visit_link_approved) && this.home.virtual_visit_link
    },
    isPublic() {
      return this.$route.name === 'ViewAdvert'
    },
    currentUrl() {
      return location.href
    },
    hasMandate() {
      return this.home.mandate_status === 'complete'
    },
    hasLeasableRoom() {
      return this.home.rooms.find(room => room.leasable)
    },
    roomComponents() {
      return this.home.rooms.map(room => ({
        component: RoomVisual,
        props: {
          room,
          home: this.home,
          user: this.user,
          warranty: this.warranty,
          hasMandate: this.hasMandate,
          close: () => this.closeLightbox(),
          contactOwner: () => {
            this.closeLightbox()
            this.triggerForDiscussion += 1
          },
          gotoCalendar: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.closeLightbox()
            this.gotoCalendar()
          },
          gotoWarranty: () => {
            this.requestWarranty()
          },
        },
      }))
    },
    tenants() {
      return this.home.rooms.reduce((res, room) => {
        if (room.user && !room.leasable) {
          res.push({ ...room.user, age: room.user.age })
        }
        return res
      }, [])
    },
    shareTitle() {
      return `Annonce Cooloc ${this.home.annonce_id} de co-location à ${this.home.city}`
    },
    shareText() {
      return `Bonjour,
je souhaite partager avec vous cette annonce pour une co-location à ${this.home.city}:
Lien: ${this.home.public_url}
Référence: ${this.home.annonce_id}`
    },
  },
  created() {
    const home = this.home
    if (!home.rooms) {
      home.rooms = []
    }
  },
  mounted() {
    const home = this.home
    if (!home.rooms) {
      home.rooms = []
    }
    // Sort rooms
    home.rooms.sort((a, b) => a.number - b.number)

    // Build image lists
    this.$set(home, 'images', { ownerType: 'homes', ownerId: home.id, loading: true, list: [] })
    home.toJSON = function () { return { ...this, images: undefined } }
    this.loadImages(home.images)

    for (const room of home.rooms) {
      this.$set(room, 'images', { ownerType: 'rooms', ownerId: room.id, loading: true, list: [] })
      room.toJSON = function () { return { ...this, images: undefined } }
      this.loadImages(room.images)
    }

    const updateUser = u => {
      console.log('User updated: ' + (u ? u.id : 'null'))
      this.user = u
    }

    if (this.loadedUser) {
      this.user = this.loadedUser
    } else {
      registrationHelpers.fetchDataUser(this, undefined, this.isPublic || this.preview)
      eventBus.$on('userChanged', updateUser)
    }

    if (this.hasMandate && !this.preview && this.$route.hash === '#visits') {
      setTimeout(this.gotoCalendar, 250)
    }
  },
  methods: {
    setPageAfterLogin(path, info) {
      sessionStorage.setItem('gotoPageAfterLogin', JSON.stringify({ path, info }))
    },
    openLightbox(sources, index) {
      if (!sources || sources.length === 0) {
        return
      }
      this.lightbox.sources = sources
      this.lightbox.slide = index + 1
      this.lightbox.key++
      this.$nextTick(() => this.lightbox.toggler = !this.lightbox.toggler)
    },
    closeLightbox() {
      this.lightbox.toggler = !this.lightbox.toggler
    },
    loadImages(imageList) {
      imageList.loading = true
      this.$http.get(`/api/images/${imageList.ownerType}/${imageList.ownerId}`).then(
        res => {
          imageList.list = res.data
          if (this.approvedOnly) {
            imageList.list = imageList.list.filter(i => i.approved)
          }
          imageList.loading = false
        },
        err => {
          imageList.list = []
          imageList.loading = false
          console.error(err)
        },
      )
    },
    roomMedias(room) {
      return room.images.list.map(img => '/image/' + img.id + '/0/0')
    },
    roomAmount(room) {
      return (room.rent_month + (room.rent_charge_month || 0) + (room.rent_supp || 0)) + room.cooloc_fees
    },
    imgStyle(img) {
      if (!img || !img.id) {
        return {
          backgroundImage: 'url(/static/images/icons/no-picture.svg)',
          backgroundColor: '#A7A9AC',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }
      }
      return {
        backgroundColor: '#' + (0x1000000 | img.color).toString(16).substring(1),
        backgroundImage: 'url(/image/' + img.id + '/0/0)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }
    },
    userStyle(user) {
      if (!user.avatar) {
        return {
          backgroundImage: 'url(/static/images/icons/no-picture.svg)',
          backgroundColor: '#A7A9AC',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }
      }
      return {
        backgroundColor: '#' + (0x1000000 | user.avatar.color).toString(16).substring(1),
        backgroundImage: 'url(/image/' + user.avatar.id + '/0/0)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }
    },
    calcRoute() {
      this.route.loading = true
      this.$http.post('/api/geo/distancematrix/' + this.home.id, {
        address: this.route.address,
      }).then(({ data }) => {
        this.route.results = data.reduce((res, { time, mode }) => {
          if (!time) {
            return res
          }
          time = Math.round(time / 60) // minutes
          let str = ''
          if (time >= 60) {
            let mins = time % 60
            if (mins < 10) mins = '0' + mins
            str = '<span>' + (time / 60 << 0) + '</span>h<span>' + mins + '</span>'
          } else if (time > 1) {
            str = '<span>' + time + '</span> mins'
          } else {
            str = '<span>' + time + '</span> min'
          }

          res[mode] = str
          return res
        }, {})
        this.route.loading = false
      }).catch(err => {
        console.error(err)
        this.route.loading = false
      })
    },
    getThumbnail(video) {
      const matches = youtubeRegex.exec(video)
      if (matches) {
        const videoId = matches[2] || matches[4]
        return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
      }
      return '/static/images/icons/no-picture.svg'
    },
    fixYoutubeUrl(url) {
      const matches = youtubeRegex.exec(url)
      if (matches) {
        const videoId = matches[2] || matches[4]
        return `https://www.youtube.com/watch?v=${videoId}`
      }
      return url
    },
    contactOwner() {
      if (this.preview) {
        return
      }
      if (this.isPublic) {
        this.contactModalData = {
          title: 'CONTACTER LE PROPRIÉTAIRE',
          subtitle: 'Pour contacter le propriétaire,\nmerci de remplir les champs ci-dessous.',
          button: 'VALIDER',
          extraInfo: {
            home_id: this.home.id,
          },
          confirm: () => {
            this.$router.push({
              name: 'ConfirmVisit',
              params: {
                type: 'contact',
              },
            })
          },
        }
      } else {
        this.$router.push({ name: 'DashboardMessages', query: { id: 'home-' + this.home.id } })
      }
    },
    openExternalChatRoom() {
      window.open(this.home.chatroom_invite_link, 'chatroom', 'menubar=0,resizable=0,width=1024,height=768')
    },
    gotoMap() {
      document.querySelector('#map').scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    gotoCalendar() {
      document.querySelector('#calendar').scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    requestWarranty() {
      if (this.preview) {
        return
      }
      if (this.user && this.user.search && this.user.search.warranty_link) {
        this.warranty.loading = true
        setTimeout(() => {
          window.location = `${this.user.search.warranty_link}/dossier_de_garantie?home_id=${this.home.id}&step=chambre`
        }, 25)
      } else {
        this.connectionModal = {
          title: 'DEPOSER UN DOSSIER',
          subtitle: 'Afin de déposer un dossier de location, veuillez vous connecter ou créer un compte',
          pageAfterLogin: `$WARRANTY_LINK/dossier_de_garantie?home_id=${this.home.id}&step=chambre`,
        }
      }
    },
    openVirtualVisit() {
      window.open(this.video360, 'virtualvisit', 'fullscreen')
    },
    joinGroup(ev) {
      if (this.preview) {
        ev.canceled = true
        return
      }
      if (this.isPublic) {
        this.connectionModal = {
          title: 'REJOINDRE LE GROUPE',
          subtitle: 'Afin de rejoindre le groupe, veuillez vous connecter ou créer un compte',
          pageAfterLogin: `/users/annonce/${this.home.id}`,
        }
        ev.canceled = true
      }
    },
    reserveMeet(ev) {
      if (this.preview) {
        ev.canceled = true
        return
      }
      if (this.isPublic && !this.user) {
        this.contactModalData = {
          title: 'DEMANDE DE RENDEZ-VOUS',
          subtitle: 'Afin de réserver une visite,\nmerci de renseigner les informations ci-dessous',
          button: 'SUIVANT',
          extraInfo: {
            home_id: this.home.id,
            request_meet: true,
            scheduled_at: ev.meet_date_time,
          },
          pageAfterLogin: `/users/annonce/${this.home.id}`,
          confirm: () => {
            this.$router.push({
              name: 'ConfirmVisit',
              params: {
                type: 'scheduled',
              },
            })
          },
        }
        ev.canceled = true
      }
    },
    pluralize(s, count) {
      return count > 1 ? s + 's' : s
    },
    ieme(num) {
      if (num === 1) {
        return 'er'
      } else if (num === 2) {
        return 'nd'
      }
      return 'ème'
    },
    age(user) {
      return user.age
    },
  },
  components: {
    FsLightbox,
    Hooper,
    HooperSlide,
    HooperNavigation,
    HooperPagination,
    EmailButton,
    WhatsAppButton,
    FacebookButton,
    TwitterButton,
    UiButton: require('@/ui/Button').default,
    UiModal: require('@/ui/Modal').default,
    ContactModal: require('@/ui/ContactModal').default,
    MessagesHome: require('../dashboard/pages/MessagesHome').default,
    Agenda: require('../dashboard/pages/agenda/Agenda').default,
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '../../../static/scss/variables';
@import "hooper/dist/hooper.css";

.homevisual {
  button {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    padding: 6px;
    text-transform: uppercase;
  }
  button.light {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #D90E16;
    background: transparent;
    border: 1px solid #D90E16;
    cursor: pointer;
  }

  .tags {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 12px;
  }
  .tags > div {
    padding: 8px;
    background: #F0F2F5;
  }
  .tags > div.tag-warning {
    background-color: rgba(255,251,230,1);
  }

  .image-gallery {
    width: 645px !important;
  }
  .image-gallery-slide .image-gallery-image {
    object-fit: cover !important;
  }
  .image-gallery-left-nav .image-gallery-svg, .image-gallery-right-nav .image-gallery-svg {
    width: 30px !important;
    height: 60px !important;
  }
  .image-gallery-thumbnail {
    width: 210px !important;
  }

  .visits_header {
    margin-top: 50px;
    color: #d90f15;
    text-align: left;
    color: #d90f15;
    font-size: 18.4px;
    font-weight: 300;
  }

  @mixin mobile() {
    @media #{$phone} {
      @content;
    }
  }

  @mixin pic-wrapper($ratio: 72%) {
    > div {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    &::after {
      content: '';
      display: block;
      padding-bottom: $ratio;
    }
  }

  @mixin grid($gutter, $width) {
    display: flex;
    flex-wrap: wrap;
    margin: -$gutter;

    > * {
      padding: $gutter;
      width: $width;
      box-sizing: border-box;
    }
  }

  width: 100%;
  margin-bottom: 50px;
  @include mobile() {
    padding: 0;
  }

  .loader-wrapper {
    height: 50px;
  }

  .home_view {
    display: flex;
    flex-direction: column;
    row-gap: 48px;
    width: 100%;
    max-width: 1200px;
    margin: 16px auto;

    @media #{$phone}, #{$tablet} {
      width: 100%;
      max-width: 100%;
      margin: 40px 0 0 0;
    }
  }

  .home_header {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;

    @media #{$phone} {
      width: 100vw;

      .home_pictures {
        width: 100vw;
        height: 320px;
        flex: 320px 0 0;
        margin-top: 24px;
        margin-bottom: 16px;
        flex-direction: column;

        .home_mainpicture {
          width: 100vw;
          height: 200px;
        }
      }
    }

    @media #{$tablet} {
      width: 100vw;

      .home_pictures {
        width: 100vw;
        height: 518px;
        flex: 518px 0 0;
        margin-top: 24px;
        margin-bottom: 16px;
        flex-direction: column;

        .home_mainpicture {
          width: 100vw;
          height: 360px;
          flex: 360px 0 0;
        }
      }
    }
  }

  h1.home_title {
    margin-top: 12px;
    margin-bottom: 16px;
    color: #D90E16;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
  }

  .homevisual__visits__h2 {
    margin-top: 4px;
    margin-bottom: 12px;
    line-height: 24px;
    font-size: 18px;
    font-weight: 600;
  }

  h2 {
    text-align: left;
    white-space: nowrap;
  }

  .home_location_address {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    line-height: 24px;
    color: #595959;
    margin-top: 16px;
    @media #{$phone}, #{$tablet} {
      padding: 0 8px;
    }

    .home_location_icon {
      flex: 24px 0 0;
      width: 24px;
      height: 24px;
      padding: 4px;
      background-color: #F0F0F0;
    }
  }

  .home_location {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #595959;
    margin-top: 16px;
    gap: 40px;

    > div {
      @include mobile() {
        width: 100%;
        margin-bottom: 50px;
      }
    }

    > div.home_location_map {
      flex: 640px 0 0;
      width: 640px;
      height: 320px;

      @media #{$phone} {
        flex: calc(100vw - 16px) 0 0;
        width: calc(100vw - 16px);
        height: 200px;
      }

      @media #{$tablet} {
        flex: calc(100vw - 16px) 0 0;
        width: calc(100vw - 16px);
        height: 280px;
      }

      .vue-map-container {
        height: 320px;
        @media #{$phone}, #{$tablet} {
          width: calc(100vw - 16px);
          margin-bottom: 30px;
        }
      }
    }

    > div.home_location_access {
      flex-grow: 1;

      .home_location_access_subtitle {
        margin-top: 4px;
        margin-bottom: 12px;
        line-height: 24px;
        font-size: 18px;
        font-weight: 600;
      }
      .home_location_access_dest {
        display: flex;
        flex-direction: row;
        height: 28px;
        > .label {
          margin-right: 8px;
        }
        > div.label {
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #000000;
        }
        > div.input {
          width: 275px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
          color: #000000;
          input {
            width: 275px;
            height: 28px;
            border: 1px solid #A6A9AC;
            color: #000000;
          }
          input::placeholder {
            color: #A6A9AC;
          }
        }
      }
      .home_location_access_results {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        > .icons {
          display: flex;
          flex-direction: row;
          column-gap: 32px;
          > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            padding: 8px;
            background-color: #F8F8F8;
            svg, img {
              width: 24px;
              height: 24px;
              path {
                fill: #000000;
              }
            }
          }
        }
        .info {
          margin-top: 20px;
        }
      }
    }
  }
  .home_address {
    text-decoration-line: underline;
  }

  .home_pictures {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .home_mainpicture {
      cursor: pointer;
      width: calc(60% - 8px);
      height: 400px;
    }

    .home_thumbnails {
      width: 40%;
      overflow-y: hidden;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 8px;
      > div {
        cursor: pointer;
        flex: calc(50% - 4px) 0 0;
        width: calc(50% - 4px);
        height: 152px;
      }
      > div:first-child {
        width: 100%;
        flex: 100% 0 0;
        height: 240px;
      }
      > div.last_pic {
        > div {
          width: 100%;
          height: 100%;
          text-align: center;
          padding: 60px 8px;
          backdrop-filter: brightness(50%);
          color: white;
          font-size: 18px;
        }
      }

      @media #{$phone} {
        width: 100vw;
        column-gap: 2%;
        > div:first-child {
          cursor: pointer;
          flex: 32% 0 0;
          width: 32%;
          height: 120px;
        }
        > div {
          cursor: pointer;
          flex: 32% 0 0;
          width: 32%;
          height: 120px;
        }
      }

      @media #{$tablet} {
        width: 100vw;
        column-gap: 2%;
        > div:first-child {
          cursor: pointer;
          flex: 32% 0 0;
          width: 32%;
          height: 160px;
        }
        > div {
          cursor: pointer;
          flex: 32% 0 0;
          width: 32%;
          height: 160px;
        }
      }
    }
  }

  .home_tenants {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 40px;

    .home_tenant {
      height: 160px;
      display: flex;
      flex-direction: row;
      column-gap: 12px;

      @media #{$phone}, #{$tablet} {
        height: 120px;
      }

      .home_tenant_pic {
        width: 160px;
        height: 160px;

        @media #{$phone}, #{$tablet} {
          width: 120px;
          height: 120px;
        }
      }
      .home_tenant_name {
        line-height: 28px;
        font-size: 20px;
        font-weight: 600;
        color: #444444;
        margin-bottom: 40px;
      }
      .home_tenant_info {
        line-height: 22px;
        font-size: 14px;
        font-weight: 600;
        color: #A6A9AC;
      }
    }
  }

  .home_summary {
    flex-grow: 2;
    display: flex;
    flex-direction: row;
    gap: 16px;
    @media #{$phone}, #{$tablet} {
      padding: 0 8px;
    }
    @media #{$phone} {
      flex-direction: column;
      gap: 8px;
    }

    .home_summary_main {
      flex-grow: 1;
    }

    .home_share {
      flex-grow: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;

      .ref {
        margin-left: 4px;
        color: #595959;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
      .label {
        margin-left: 4px;
        color: #D90E16;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
      .buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
      }
    }
  }

  .home_options {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .home_provider {
    box-sizing: border-box;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    border: 1px solid #FF7875;
    border-radius: 10px;
    background: #FFF1F0;
    color: #FF7875;
    padding: 1px 8px;
    width: max-content;
  }

  .home_favorites {
    display: flex;
    flex-direction: row;
    column-gap: 12px;
    cursor: pointer;
  }
  .home_favorites > span {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #444444;
  }

  .home_description {
    margin: 8px 0;
  }
  .home_description > pre {
    white-space: pre-wrap;
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #000000;
  }

  .home_actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 24px;
    @media #{$phone}, #{$tablet} {
      padding: 0 8px;
    }
  }
  .home_actions > button {
    flex-grow: 1;
    max-width: 50%;
  }

  .home_block {
    @media #{$phone}, #{$tablet} {
      padding: 0 8px;
    }
  }

  .home_block_content {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    align-items: flex-start;
  }

  .home_block h3 {
    margin-bottom: 8px;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
  }

  .home_subtitle {
    display: flex;
    flex-direction: row;
    column-gap: 40px;
    align-items: baseline;
    margin-bottom: 16px;
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 26px;
      line-height: 32px;
      background: linear-gradient(90deg, #D90E16 0%, #D90E16 37.5%, #F00281 100%);
      background-clip: text;
      -webkit-background-clip: text;
      text-fill-color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }

  .home_subtitle > span {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #A6A9AC;
  }

  .home_description {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
  }

  .home_rooms {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 60px;
    row-gap: 40px;
    justify-content: space-between;

    @media #{$tablet} {
      column-gap: 16px;
    }

    .home_room {
      width: 360px;
      position: relative;

      @media #{$tablet} {
        width: calc(50vw - 16px);
      }

      @media #{$phone} {
        width: calc(100vw - 16px);
      }

      .hooper {
        height: 240px;
        cursor: pointer;
      }
      button.hooper-prev, button.hooper-next {
        width: 21px;
        height: 21px;
        padding: 0px;
        border-radius: 21px;
        background-color: white;
        svg {
          width: 21px;
          height: 21px;
        }
        svg path:last-child {
          fill: #C0C0C0;
        }
      }
      button.hooper-prev {
        left: 16px;
      }
      button.hooper-next {
        right: 16px;
      }

      .home_room_info {
        margin-top: 8px;
        padding: 2px 0px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        > div {
          flex-grow: 0;
          flex-shrink: 0;
          line-height: 28px;
          font-size: 18px;
          font-weight: 600;
          color: #444444;
        }
        > div.price {
          font-size: 22px;
          color: #262626;
          vertical-align: baseline;
        }
        > div > span.subprice {
          font-size: 12px;
          font-weight: 400;
          vertical-align: bottom;
          color: #595959;
        }
      }

      .home_room_tenant_pic {
        position: absolute;
        top: 152px;
        right: 0px;
        width: 88px;
        height: 88px;
      }

      .home_room_leasable {
        position: absolute;
        display: flex;
        justify-content: space-between;
        top: 16px;
        left: 16px;
        height: 28px;
        padding: 2px 2px 2px 10px;
        border-radius: 28px;
        background-color: rgba(255, 255, 255, 0.8);
        gap: 12px;
        > div.label {
          font-size: 14px;
          font-weight: 600;
          color: #444444;
          line-height: 20px;
        }
        > div.color {
          width: 24px;
          height: 24px;
          border-radius: 24px;
          background-color: #00A23A;
        }
      }
    }
  }
  .room {
    min-width: 360px;
    flex-shrink: 1;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .room_image {
    height: 240px;
  }
  .room_image > img {
    object-fit: cover;
    height: 240px;
  }

  .room_info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 16px;
  }
  .room_info > .room_name {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
  }
  .room_info > .room_price {
    display: flex;
    column-gap: 4px;
    align-items: baseline;
  }
  .room_price > span {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
  }
  .room_price > .room_price_suffix {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #595959;
  }
  .room_actions {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 24px;
  }
  .room_actions > button {
    flex-grow: 1;
  }

  .button {
    font-family: $main-font;
    font-weight: 400;
  }

  &__header {
    color: $red;
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__city {
      color: #766E6A;
    }

    .button {
      border: none;
      font-size: 18px;

      .svg-icon {
        width: 25px;
        height: 25px;

        path {
          fill: $red;
        }
      }
      &:hover {
        background: transparent;
        color: $red;
      }
    }
  }

  &__actions {
    display: flex;
    align-items: stretch;
    justify-content: space-evenly;
    margin-bottom: 40px;
    column-gap: 16px;
    height: max-content;

    button {
      font-size: 17px;
      line-height: 22px;
      font-weight: 600;
      color: $red;
      padding: 8px 25px;
      min-height: 43px;
    }
  }

  &__users {
    &__h1 {
      color: #766E6A;
      text-align: center;
      margin-bottom: 20px;
    }
    &__wrapper {
      display: flex;
      justify-content: center;
      margin: -15px;
    }
  }
  &__user {
    width: 90px;
    margin: 15px;
    text-align: center;
    color: #766E6A;
    overflow-wrap: anywhere;

    &__pic {
      width: 70px;
      height: 70px;
      margin: 0 auto 7px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    div {
      color: $red;
    }
  }

  &__h1 {
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    margin: 50px 0 30px;
    color: $red;
  }

  &__pics {
    justify-content: center;
    @include grid(32px, 33.33%);
    @include mobile() {
      @include grid(14px, 50%);
    }

    > div {
      @include pic-wrapper();
    }
  }

  &__vids {
    justify-content: center;
    @include grid(32px, 328px);
    margin-top: 20px;

    @include mobile() {
      @include grid(14px, 100%);
      margin-top: 20px;
    }

    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    > div, > a {
      display: block;
      @include pic-wrapper();

      position: relative;
      img {
        position: absolute;
        width: 70px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }

  &__rooms {
    justify-content: center;
    @include grid(25px, 33.33%);
    @include mobile() {
      @include grid(14px, 100%);
    }
  }
  &__room {
    border: 1px solid #C4C4C4;
    color: #766E6A;
    font-weight: 400;
    font-size: 25px;
    position: relative;

    &__name {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 96px;
      height: 30px;
      padding: 0 5px;
      background: #FFF;
      color: $red;
      font-size: 16px;
      text-align: center;
      line-height: 30px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &__info, &__more {
      padding: 10px 0;
      text-align: center;
    }
    &__small1 {
      font-size: 17px;
    }
    &__small2 {
      font-size: 14px;
    }
    &__more {
      cursor: pointer;
    }

    &__nopic {
      width: 100%;
      height: 240px;
      background-image: url(/static/images/icons/no-picture.svg);
      background-color: #A7A9AC;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }

  &__location {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;

    > div {
      width: 50%;
      @include mobile() {
        width: 100%;
      }
    }

    .vue-map-container {
      height: 263px;
      @include mobile() {
        margin-bottom: 30px;
      }
    }

    &__route {
      padding: 0 73px 0 46px;
      color: #766E6A;
      @include mobile() {
        padding: 0;
      }

      &__subtitle {
        text-align: center;
        margin: 0 -73px 0 -46px;
        @include mobile() {
          text-align: left;
          margin: 0;
        }
      }
      &__title {
        color: $blue;
        text-align: center;
        margin: 26px 0;
      }
      &__input {
        margin-right: -73px;
        margin-bottom: 26px;
        display: flex;
        justify-content: space-between;
        @include mobile() {
          flex-direction: column;
          margin-right: 0;
        }

        input {
          height: 34px;
          width: calc(100% - 73px);
          @include mobile() {
            width: 100%;
          }
        }
        .button {
          height: 34px !important;
          line-height: 34px;
          @include mobile() {
            margin-top: 20px;
          }
        }
      }
      &__icons {
        display: flex;
        justify-content: space-between;

        svg {
          display: block;
          width: 100%;
          margin-bottom: 10px;
        }
        span span {
          color: $blue;
        }
      }
      &__info {
        font-size: 12px;
        font-style: italic;
        text-align: center;
        margin-top: 28px;
      }
    }
  }

  &__collapsible {
    border-top: 1px solid #C4C4C4;
    cursor: pointer;
    margin: 30px 0 15px;
    &__h1 {
      margin: 15px 0 0;
      color: $red;
      font-size: 18.4px;
      font-weight: 300;
    }

    position: relative;
    &::after {
      content: '';
      display: block;
      width: 20px;
      height: 8px;
      position: absolute;
      top: 20px;
      right: 20px;
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='8' fill='none' viewBox='0 0 20 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L10 7L19 1' stroke='%23766E6A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      transition: transform .2s;
    }
    &--active::after {
      transform: rotate(180deg);
    }
  }
  &__shared-places, &__shared-services, &__maininfo, &__desc {
    color: #766E6A;
  }

  &__shared-places {
    @include grid(5px, 33.33%);
    @include mobile() {
      @include grid(5px, 100%);
    }
  }
  &__shared-services {
    flex-direction: column;
    > div {
      padding: 5px 0;
    }
    &__info {
      text-align: right;
      font-size: 12px;
      font-style: italic;
    }
  }
  &__maininfo {
    @include grid(30px, 50%);
    @include mobile() {
      @include grid(20px, 100%);
    }

    > div > div {
      padding: 5px 0;
    }

    &__letters {
      display: inline-flex;
      margin-top: 12px;

      > div {
        width: 16px;
        height: 24px;
        color: #FFF;
        font-size: 14px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      > div#{&}--active {
        position: relative;
        margin: 0px 2px;
        top: -5px;
        width: 24px;
        height: 30px;
        border-radius: 4px;
        border: 2px solid #FFF;
        box-sizing: content-box;
        font-size: 16px;
      }

      &--dpe > div {
        &:nth-child(1) { background: #379932; }
        &:nth-child(2) { background: #3ACC31; }
        &:nth-child(3) { background: #CDFD33; color: #381A1A; }
        &:nth-child(4) { background: #FBEA49; color: #381A1A; }
        &:nth-child(5) { background: #FCCC2F; color: #381A1A;}
        &:nth-child(6) { background: #FB9C34; }
        &:nth-child(7) { background: #FA1C1F; }
      }
      &--ges {
        top: 3px;
        > div {
          &:nth-child(1) { background: #F6EDFE; color: #381A1A; }
          &:nth-child(2) { background: #E4C7FB; color: #381A1A; }
          &:nth-child(3) { background: #D2ADF1; color: #381A1A; }
          &:nth-child(4) { background: #C99AEF; color: #381A1A; }
          &:nth-child(5) { background: #B77AE9; }
          &:nth-child(6) { background: #A659E9; }
          &:nth-child(7) { background: #8835D9; }
        }
      }
    }

    &__charges {
      max-width: 200px;
      &::before {
        content: '';
        display: block;
        float: right;
        width: 13px;
        height: 11px;
        background-image: url("data:image/svg+xml,%3Csvg width='13' height='11' viewBox='0 0 13 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.6944 0L4.27778 6.6L2.13889 4.4L0 6.6L4.27778 11L12.8333 2.2L10.6944 0Z' fill='%2375CD31'/%3E%3C/svg%3E");
      }
    }
  }
  &__desc {
    border: 1px solid #C4C4C4;
    white-space: pre-line;
    padding: 20px;
  }

  .hooper-slide {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-position: center;
    background-repeat: no-repeat;
  }
  .hooper-prev, .hooper-next {
    .icon path:last-child {
      fill: #FFF;
    }
  }
  .hooper-indicator {
    width: 10px;
    height: 10px;
    border: 1px solid #766E6A;
    border-radius: 100%;
    background: #C8C2C0;
    &.is-active, &:hover {
      background: #FFF;
    }
  }
  .hooper-pagination {
    bottom: 10px;
  }

  &__visits {
    &__h1 {
      margin-top: 50px;
      color: $red;
      text-align: center;
    }
    &__h2 {
      margin-top: 20px;
      margin-bottom: 18px;
      color: #766E6A;
      text-align: left;
    }
    .dispcalendar {
      margin: 0 auto;
      width: 100%;
      max-width: 700px;
    }
  }
}
</style>
